import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import SafeUrlAssembler from 'safe-url-assembler';
import { ApiEndpointService } from '../../core/services/api-endpoint.service';
import { HttpClientService } from '../../core/services/http/http-client.service';
import { IDwRewardShipAdvancedFilterParameter } from '../models/dw-rewardship-advanced-filter-parameter.interface';
import { IRewardShip } from '../models/rewardShip.interface';


@Injectable()
export class RewardshipService {
    public advancedFilterParameterChanged$ = new Subject<IDwRewardShipAdvancedFilterParameter>();

    constructor(// private httpService: HttpService,
        private httpClientService: HttpClientService,
        private apiEndpointService: ApiEndpointService,
    ) {

    }


    /**
     * Gets Rewards history.
     *
     * @returns {Observable}
     */
    public getRewardsHistory(pageIndex: number, pageSize: number): Observable<IRewardShip[]> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('getRewardsHistory'))
            .query({
                page: pageIndex,
                per_page: pageSize,
            })
            .toString();
        return this.httpClientService.get<IRewardShip[]>(endpoint);
    }

    /**
     * Redeem the rewards.
     *
     * @returns {Observable}
     */
    public redeemRewards(): Observable<any> {
        const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('redeemRewards')).toString();
        return this.httpClientService.put<any>(endpoint, '');
    }

    /**
     * Gets Rewards history header.
     *
     * @returns {Observable}
     */
    public getRewardsHistoryHeader(): Observable<any> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('getRewardsHistoryHeader'))
            .toString();
        return this.httpClientService.get<any>(endpoint);
    }

    /**
     * Returns true if the terms and conditions have been accepted, otherwise false
     * @returns
     */
    public getTermsAndCondAccepted(): Observable<any> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('getTermsAndCondAcceptedForOthers'))
            .toString();
        return this.httpClientService.get<any>(endpoint);
    }

    public postTCFlag(): Observable<any> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('postTCFlagForOthers'))
            .toString();
        return this.httpClientService.post<any>(endpoint, true);
    }
}
